import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/main';

const store = configureStore({
    reducer: rootReducer, // Use the combined root reducer
});

export default store;
